/**
 * jQuery 전역 참조 shim (ESM).
 *
 * jQuery 는 master 레이아웃에서 classic <script> 로 먼저 로드되어
 * window.jQuery / window.$ 로 존재한다. 번들 안에서 'jquery' 를 import
 * 하는 곳(app.js, 페이지 .ts 등)이 이 전역 인스턴스를 공유하도록,
 * vite.config.js 에서 'jquery' 를 이 파일로 alias 한다.
 *
 * jQuery 플러그인(slick·select2·jquery-serializejson·lightbox2)은 번들에
 * 넣지 않고 classic <script> 로 로드한다. 그 플러그인들은 내부에서
 * require('jquery') 를 하는데, 번들에 넣으면 CJS↔ESM interop 이 dev 와
 * build 에서 다르게 동작해(네임스페이스 객체 전달 / default 부재 등)
 * $.fn 부착이 깨지기 때문이다. classic 로드는 전역 jQuery 에 직접 붙어
 * 이 문제를 원천 차단한다. 그래서 이 shim 은 순수 ESM default 로 충분하다.
 */
export default window.jQuery;
export const jQuery = window.jQuery;
